import type { BlockType } from '~/types/AppData/Blocks/BlockType';

/**
 * Generate a unique key for a mapping function
 *
 * @param block
 * @param index
 */
export const getKeyFromBlock = (
  block: BlockType,
  index: number
): string | number => {
  if ('url' in block.value && block.value.url) {
    return block.value.url;
  }

  if ('src' in block.value) {
    return block.value.src;
  }

  if ('html' in block.value) {
    return block.value.html;
  }

  if ('text' in block.value) {
    return block.value.text;
  }

  if ('title' in block.value) {
    return block.value.title;
  }

  if ('items' in block.value) {
    return 'list-' + block.value.items?.length;
  }

  return index;
};
